import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["allowClear", "defaultOpen", "onBlur", "showHour", "showMinute", "showSecond", "autoTriggerChange", "inputShowValue", "tabIndex", "inputReadOnly", "clsPrefix"];

var _dec, _class;

import "core-js/modules/es6.object.assign.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Created by chief on 17/4/6.
 */
import Calendar from "./rc-calendar";
import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { KeyCode } from '../../wui-core/src';
import Picker from "./rc-calendar/Picker"; // import FormControl from "../../wui-input/src";

import TimePickerPanel from "rc-time-picker/lib/Panel";
import moment from "moment";
import Icon from "../../wui-icon/src";
import classnames from 'classnames';
import InputGroup from '../../wui-input-group/src';
import Input from '../../wui-input/src'; // import zhCN from "./locale/zh_CN";

import omit from 'omit.js';
import { WebUI, prefix } from "../../wui-core/src/index.js";
import { getLangInfo } from "./lang-utils";

function noop() {}

var timerDatePicker = true;
var defaultProps = {
  closeIcon: function closeIcon() {
    return /*#__PURE__*/React.createElement(Icon, {
      type: "uf-close-c"
    });
  },
  suffixIcon: function suffixIcon() {
    return /*#__PURE__*/React.createElement(Icon, {
      type: "uf-calendar"
    });
  },
  focusOnOpen: true,
  defultSelect: false,
  onOpenChange: function onOpenChange() {},
  onChange: function onChange() {},
  locale: 'zh-cn',
  open: false,
  showMonthInput: false,
  onKeyDown: function onKeyDown() {},
  renderError: function renderError() {},
  placeholder: '',
  allowClear: true,
  format: "YYYY-MM-DD",
  showSecond: true,
  showHour: true,
  showMinute: true,
  autoTriggerChange: false,
  inputTabKeyOpen: false,
  inputReadOnly: false,
  // Set the readonly attribute of the input tag (avoids virtual keyboard on touch devices)
  validatorFunc: function validatorFunc() {
    return true;
  }
};
var DatePicker = (_dec = WebUI({
  name: "datepicker",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(DatePicker, _Component);

  var _super = _createSuper(DatePicker);

  function DatePicker(_props, context) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _super.call(this, _props, context);

    _defineProperty(_assertThisInitialized(_this), "initValue", function (props) {
      var value = props.value || props.defaultValue;

      if (value) {
        if (typeof value == 'string') {
          if (moment(value, _this.props.format).isValid()) {
            value = moment(value, _this.props.format);
          } else {
            console.error('value is not in the correct format');
            value = '';
          }
        } else if (value.format && value.isValid && value.isValid()) {
          value = value;
        } else {
          console.error('value is not in the correct format');
          value = '';
        }
      }

      return value;
    });

    _defineProperty(_assertThisInitialized(_this), "getValue", function (value) {
      var format = _this.props.format;

      if (value.format) {
        if (typeof format == 'string') {
          return value.format(format);
        } else {
          return value.format(format[0]);
        }
      }

      return value;
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
      _this.setState({
        value: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "inputFocus", function () {
      var _this$props = _this.props,
          format = _this$props.format,
          validatorFunc = _this$props.validatorFunc,
          disabledDate = _this$props.disabledDate,
          inputTabKeyOpen = _this$props.inputTabKeyOpen;
      var input = document.querySelector(".".concat(prefix, "-date-input"));

      if (input) {
        if (input.value) {
          input.select();
        } else {
          input.focus();
        }

        input.onkeydown = function (e) {
          // 日历的input
          if (e.keyCode == KeyCode.DELETE) {
            input.value = '';

            _this.fireChange('', '');
          } else if (e.keyCode == KeyCode.ESC || e.keyCode == KeyCode.TAB && !inputTabKeyOpen) {
            _this.setState({
              open: false
            });

            e.target._dataTransfer = {
              owner: ReactDOM.findDOMNode(_this.outInput),
              _target: e.target,
              open: false
            }; // input.blur();
            // 按esc时候焦点回到input输入框

            ReactDOM.findDOMNode(_this.outInput).focus();
            ReactDOM.findDOMNode(_this.outInput).select(); // e.stopPropagation();

            var v = _this.state.value;

            _this.props.onOpenChange(false, v, v && _this.getValue(v) || '');
          } else if (e.keyCode == KeyCode.ENTER) {
            var parsed = moment(input.value, format, true);
            var isDisabled = disabledDate && disabledDate(parsed);

            if (parsed.isValid && parsed.isValid() && validatorFunc(input.value) && !isDisabled) {
              _this.setState({
                open: false
              });

              var _v = _this.state.value;

              _this.props.onOpenChange(false, _v, _v && _this.getValue(_v) || '');

              ReactDOM.findDOMNode(_this.outInput).focus();
            }

            if (!input.value) {
              _this.setState({
                open: false
              });
            }
          } else if (e.keyCode >= 37 && e.keyCode <= 40) {
            // 向下
            // 自定义_dataTransfer
            e.target._dataTransfer = {
              owner: ReactDOM.findDOMNode(_this.outInput),
              _target: e.target,
              open: _this.state.open
            };
          }

          _this.props.onKeyDown && _this.props.onKeyDown(e);
        };
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onOpenChange", function (open) {
      var props = _this.props;

      var self = _assertThisInitialized(_this);

      _this.setState({
        open: open
      }, function () {
        if (open) {
          setTimeout(function () {
            self.inputFocus();
          }, 0);
        }
      });

      var value = self.state.value;
      props.onOpenChange(open, value, value && _this.getValue(value) || '');

      if (open) {
        setTimeout(function () {
          self.inputFocus();
        }, 200);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCalendarChange", function (value) {
      var props = _this.props;

      _this.setState({
        value: value,
        inputValue: value && _this.getValue(value) || ''
      });

      _this.fireChange(value, value && _this.getValue(value) || '');
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      var props = _this.props;

      _this.setState({
        value: value && Object.assign(value, {
          _type: 'date'
        }) || value,
        inputValue: value && _this.getValue(value) || ''
      });

      if (timerDatePicker) {
        clearTimeout(_this.timerout);

        _this.fireChange(value, value && _this.getValue(value) || '');

        timerDatePicker = false;
        _this.timerout = window.setTimeout(function () {
          timerDatePicker = true;
        }, 300);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      var props = _this.props;
      if (props.keyboardInput) e.stopPropagation();
      var value = _this.state.value;

      if (props.keyboardInput) {
        props.onClick && props.onClick(e.nativeEvent, value || null, _this.state.inputValue);
      } else {
        props.onClick && props.onClick(e.nativeEvent, value || null, value && _this.getValue(value) || '');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "inputChange", function (value, e) {
      if (_this.props.keyboardInput) e.stopPropagation();

      _this.setState({
        inputValue: value
      });

      if (moment(value, _this.props.format, true).isValid() && _this.props.validatorFunc(value)) {
        _this.setState({
          value: moment(value, _this.props.format)
        });

        value = moment(value, _this.props.format);

        _this.fireChange(value, value && _this.getValue(value) || '');
      } else {
        _this.fireChange(null, value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "outInputFocus", function (e) {
      if (_this.props.hasOwnProperty('open')) e.stopPropagation();
      _this.props.outInputFocus && _this.props.outInputFocus(e);
    });

    _defineProperty(_assertThisInitialized(_this), "iconClick", function (e) {
      _this.props.iconClick && _this.props.iconClick(e);
    });

    _defineProperty(_assertThisInitialized(_this), "outInputKeydown", function (e) {
      // 外部（非弹窗日历）核心input
      if (e.keyCode == KeyCode.DELETE) {
        _this.setState({
          inputValue: ''
        });

        _this.fireChange('', '');
      } else if (e.keyCode == KeyCode.ESC) {
        _this.setState({
          open: false
        });

        e.target._dataTransfer = {
          open: false,
          owner: e.target,
          _target: e.target,
          ownerIsTarget: true
        };
        var value = _this.state.inputValue;

        if (moment(value, _this.props.format).isValid() && _this.props.validatorFunc(value)) {
          _this.setState({
            value: moment(value, _this.props.format)
          });

          value = moment(value, _this.props.format);

          _this.fireChange(value, value && _this.getValue(value) || '');
        } else {
          _this.fireChange(null, value);
        }
      }

      if (_this.props.outInputKeydown) {
        _this.props.outInputKeydown(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (e) {
      _this.setState({
        allowClear: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (e) {
      _this.setState({
        allowClear: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clear", function (e) {
      e.stopPropagation();

      _this.setState({
        inputValue: '',
        value: '',
        panelValue: null
      });

      _this.fireChange('', '');
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (value) {
      _this.setState({
        value: value
      });

      _this.props.onSelect && _this.props.onSelect(value, value && _this.getValue(value) || ''); // ReactDOM.findDOMNode(this.outInput).focus()
    });

    _defineProperty(_assertThisInitialized(_this), "onDateInputBlur", function (e) {
      var input = document.querySelector(".".concat(prefix, "-date-calendar-input"));
      var value;

      if (input) {
        value = input.value ? input.value : '';
      }

      _this.props.onDateInputBlur && _this.props.onDateInputBlur(e, value);
    });

    _defineProperty(_assertThisInitialized(_this), "onDateHover", function () {
      var _this$props2 = _this.props,
          format = _this$props2.format,
          inputShowValue = _this$props2.inputShowValue;

      var value = _this.state.value,
          newValue = value && _this.getValue(value);

      if (!_this.outInput || !_this.outInput.state) return;
      var inputValue = _this.outInput.state.value;
      inputValue = format ? inputValue : inputValue && _this.getValue(moment(inputValue));

      if (newValue && !inputShowValue && inputValue !== newValue) {
        _this.fireChange(value, newValue || '');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "fireChange", function (value, stringValue) {
      _this.fileChange && _this.props.onChange(value, stringValue);
      _this.fileChange = false;
      _this.fileChangeTimer = window.setTimeout(function () {
        _this.fileChange = true;
      }, 10);
    });

    var langInfo = getLangInfo(_props.locale); //获取语言包信息

    _this.state = {
      langInfo: langInfo,
      // type: "month",
      value: _this.initValue(_props),
      panelValue: _props.panelValue ? _props.value || _props.defaultValue ? null : moment(_props.panelValue) : '',
      // value和defaultValue的优先级高于panelValue
      open: _props.open || false,
      inputValue: _this.initValue(_props),
      allowClear: false
    };
    _this.fileChange = true;
    return _this;
  }

  _createClass(DatePicker, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var value = null;

      if ("value" in nextProps) {
        value = this.initValue(nextProps), this.setState({
          value: value,
          inputValue: nextProps.value && this.getValue(nextProps.value) || ''
        });
      }

      if ("panelValue" in nextProps) {
        this.setState({
          panelValue: value ? null : moment(nextProps.panelValue)
        });
      }

      if ("open" in nextProps) {
        this.setState({
          open: nextProps.open
        });
      }

      if ("suffixIcon" in nextProps) {
        this.setState({
          suffixIcon: nextProps.suffixIcon
        });
      }

      if ("locale" in nextProps) {
        var langInfo = getLangInfo(nextProps.locale); //获取语言包信息

        this.setState({
          langInfo: langInfo
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var state = this.state;
      var props = this.props;

      var allowClear = props.allowClear,
          defaultOpen = props.defaultOpen,
          onBlur = props.onBlur,
          showHour = props.showHour,
          showMinute = props.showMinute,
          showSecond = props.showSecond,
          autoTriggerChange = props.autoTriggerChange,
          inputShowValue = props.inputShowValue,
          tabIndex = props.tabIndex,
          inputReadOnly = props.inputReadOnly,
          clsPrefix = props.clsPrefix,
          others = _objectWithoutProperties(props, _excluded);

      var value = state.value;
      var pickerChangeHandler = {};
      var calendarHandler = {};
      var autofocus = !this.state.open && this.props.autofocus ? {
        autofocus: 'autofocus'
      } : null;

      if (props.showTime) {
        calendarHandler = {
          // fix https://github.com/ant-design/ant-design/issues/1902
          onSelect: this.handleChange
        };
      } else {
        pickerChangeHandler = {
          onChange: this.handleChange
        };
      }

      var splitNumber = '3';
      if (!showHour) splitNumber -= 1;
      if (!showMinute) splitNumber -= 1;
      if (!showSecond) splitNumber -= 1;
      var calendarProps = {};

      if (autoTriggerChange) {
        calendarProps.value = value;
        calendarProps.onChange = this.handleCalendarChange;
      } else {
        calendarProps.onChange = noop;
      }

      var calendar = /*#__PURE__*/React.createElement(Calendar, _extends({
        timePicker: props.showTime ? /*#__PURE__*/React.createElement(TimePickerPanel, {
          className: 'time-split-' + splitNumber,
          showHour: showHour,
          showMinute: showMinute,
          showSecond: showSecond,
          defaultValue: moment(moment().format("HH:mm:ss"), "HH:mm:ss")
        }) : null
      }, omit(props, ['value', 'locale']), calendarProps, {
        locale: state.langInfo.langMap,
        onSelect: this.handleSelect,
        onInputBlur: this.onDateInputBlur,
        panelValue: state.panelValue
      }));
      var keyboardInputProps = {};

      if (props.keyboardInput) {
        keyboardInputProps.readOnly = false;
        keyboardInputProps.onChange = this.inputChange;
        keyboardInputProps.value = inputShowValue || (state.inputValue && state.inputValue.format && state.inputValue.isValid && state.inputValue.isValid() && this.props.validatorFunc(state.inputValue) ? state.inputValue.format(props.format) : state.inputValue);
      } else {
        keyboardInputProps.readOnly = true;
        keyboardInputProps.value = inputShowValue || value && this.getValue(value) || "";
      }

      var disabledCls = others.disabled ? "".concat(clsPrefix, "-container-disabled") : '';
      var classes = classnames("".concat(clsPrefix, "-container"), props.className, disabledCls);
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classes,
        onMouseEnter: this.onDateHover
      }, omit(others, ['inputReadOnly', 'onDateInputBlur', 'getPopupContainer', 'showToday', 'renderExtraFooter', 'keyboardInput', 'showDateInput', 'showTime', 'closeIcon', 'suffixIcon', 'focusOnOpen', 'defultSelect', 'onOpenChange', 'locale', 'showMonthInput', 'onKeyDown', 'renderError', 'format', 'placeholder', 'disabledTime', 'onChange', 'disabledDate', 'iconClick', 'outInputKeydown', 'panelValue', 'className', 'allowClear', 'autoTriggerChange', 'showTime', 'validatorFunc', 'inputTabKeyOpen', 'destroyOnClose', 'disabledYear'])), /*#__PURE__*/React.createElement(Picker, _extends({
        animation: "slide-up"
      }, props, pickerChangeHandler, {
        onOpenChange: this.onOpenChange,
        calendar: calendar,
        open: 'defaultOpen' in props ? defaultOpen : this.state.open,
        value: state.value
      }), function () {
        return /*#__PURE__*/React.createElement(InputGroup, {
          simple: true,
          className: "".concat(clsPrefix, "-input-group"),
          onMouseEnter: _this2.onMouseEnter,
          onMouseLeave: _this2.onMouseLeave
        }, /*#__PURE__*/React.createElement(Input, _extends({
          tabIndex: tabIndex,
          ref: function ref(_ref) {
            return _this2.outInput = _ref;
          },
          disabled: props.disabled,
          placeholder: _this2.props.placeholder,
          onClick: function onClick(event) {
            _this2.onClick(event);
          },
          focusSelect: props.defaultSelected,
          onFocus: function onFocus(v, e) {
            _this2.outInputFocus(e);
          },
          onKeyDown: _this2.outInputKeydown,
          readOnly: inputReadOnly // value={(value && value.format(props.format)) || ""}

        }, keyboardInputProps, autofocus)), allowClear && _this2.state.value && _this2.state.allowClear && !props.disabled ? /*#__PURE__*/React.createElement(Input.Button, {
          shape: "border",
          onClick: _this2.clear
        }, props.closeIcon()) : /*#__PURE__*/React.createElement(Input.Button, {
          shape: "border",
          onClick: function onClick(e) {
            props.keyboardInput ? _this2.iconClick(e) : '';
          }
        }, typeof props.suffixIcon === "function" ? props.suffixIcon() : props.suffixIcon));
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.open && !this.state.open) {
        this.outInput && ReactDOM.findDOMNode(this.outInput).focus(); // 按esc时候焦点回到input输入框
      }
    }
  }]);

  return DatePicker;
}(Component)) || _class);
export default DatePicker;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/DatePicker.js